import { ROLE_DICT } from '../../../../constants';

import usersTableColumnHtml from './usersTableColumn.html';

class UsersTableColumnCtrl {
  roleDict = ROLE_DICT;

  constructor(Authentication, PersonaCollection) {
    'ngInject';

    Object.assign(this, { Authentication, PersonaCollection });
  }

  classifyStatusText(text = '') {
    return text.replace(/\s/g, '-').toLowerCase();
  }

  onItemSelect(userId) {
    const changes = { [userId]: this.selectedItemIds[userId] };
    this.onSelectionChange({ changes });
  }
}

export default function rosterTableColumn() {
  return {
    restrict: 'A',
    templateUrl: usersTableColumnHtml,
    bindToController: true,
    controller: UsersTableColumnCtrl,
    controllerAs: 'ctrl',
    scope: {
      selectedItemIds: '=',
      disableBulkActions: '<',
      user: '<',
      type: '<',
      isSelfInvitedUsersTable: '<',
      onSelectionChange: '&?',
    },
  };
}
